import { OnInit } from '@angular/core';
import { SidebarNavService } from "@app/shared/cs-components/sidebar-nav/services/sidebar-nav.service";
import { NodeOptionsObject } from "@app/workflow-common/diagram-view2/models/node.model";
import { WorkflowhttpService } from "@app/workflow-common/services/workflowhttp.service";
import { CommonDataSource } from "@app/workflow-common/services/CommonDataSource";
import { CsToastBoxService } from "@app/services";
import { TranslateService } from "@ngx-translate/core";
var AutomationStepComponent = /** @class */ (function () {
    function AutomationStepComponent(_workflowHttp, _toastBox, _translate) {
        this._workflowHttp = _workflowHttp;
        this._toastBox = _toastBox;
        this._translate = _translate;
        this.dagSource = undefined;
        this.workflowData = undefined;
        this.isDraftMode = undefined;
        this.closeFullScreenModal = undefined;
        this.currentStep = 'custom_automation';
        this.nodes = [];
        this.isValid = false;
    }
    AutomationStepComponent.prototype.ngOnInit = function () {
        console.log('AutomationStepComponent', this.workflowData, this.dagSource, this.metaData);
        this.nodeOptions = new NodeOptionsObject({
            title: this.metaData.name,
            objectName: this.objectName,
            enablePan: true,
            workflowType: 'CustomAutomation',
            showAddChild: true,
            metaData: this.metaData,
            isDraftMode: !!this.workflowData.status == false,
            autosave: true,
            workflowId: this.workflowData ? this.workflowData.id : undefined,
        });
        this.setActivationConfirmationModalConfig();
        this.setWarningModalConfig();
        var _dagSource = this.dagSource ? Object.values(this.dagSource) : [];
        if (_dagSource.length) {
            this.isValid = this.dagSource['endBlocks'].length > 0;
        }
    };
    AutomationStepComponent.prototype.onUpdatedNode = function (dagSourceModel) {
        this.isValid = dagSourceModel.endBlocks.length > 0;
    };
    AutomationStepComponent.prototype.goBack = function () {
        this.sidebarNavService.goTo(this.currentStep, 'prev');
    };
    AutomationStepComponent.prototype.goToNext = function () {
        if (this.metaData['status'].toLowerCase() != 'active') {
            this.warningModalConfig.showModal = true;
            return;
        }
        if (!this.workflowData) {
            this.closeFullScreenModal();
            return;
        }
        var status = this.workflowData.status;
        if (status) {
            this.closeFullScreenModal();
        }
        else {
            this.statusActivationConfirmation.showModal = true;
        }
    };
    AutomationStepComponent.prototype.setWarningModalConfig = function () {
        this.warningModalConfig = {
            showModal: false,
            modalType: 'warning',
            title: 'Activation blocked',
            message: {
                warningTxt: this._translate.instant('Automation.activation.warning.message', {
                    screenType: CommonDataSource.automationTitleReplace[this.screenName]
                }),
                helpTxtList: []
            }
        };
    };
    AutomationStepComponent.prototype.setActivationConfirmationModalConfig = function () {
        this.statusActivationConfirmation = {
            modalType: 'confirm',
            actionText: 'ACTIVATE',
            confirmBtnType: 'DEFAULT',
            confirmBtnText: "CONFIRM",
            confirmBxValidationMsg: '',
            itemText: "Automation",
            showModal: false,
            closeText: 'Con.Save.as.draft',
            // message: {warningTxt: 'Confirm.Status.Activation.Message', helpTxtList: []},
            message: {
                warningTxt: 'Confirm.Status.Activation.Message',
                helpTxtList: ['Activate.Now.Or.Save.As.Draft']
            },
            title: 'Confirm.Activation',
            doAction: this.activateAutomation.bind(this),
            actionArg: '',
        };
    };
    AutomationStepComponent.prototype.activateAutomation = function (args, cb) {
        var _this = this;
        var _a = this.workflowData, id = _a.id, status = _a.status;
        var automationActivate = {
            workflowId: id,
            status: true
        };
        this._workflowHttp.automationStatusUpdate(id, { automationActivate: automationActivate })
            .subscribe({
            next: function (resp) {
                if (resp.hasOwnProperty('automationActivate')) {
                    cb('SUCCESS');
                    _this.closeFullScreenModal();
                }
                if (resp.hasOwnProperty('error')) {
                    _this._toastBox.show(resp['message']);
                }
            }
        });
    };
    AutomationStepComponent.prototype.onCloseConfirmation = function (isCloseBtn, type) {
        this.closeFullScreenModal();
    };
    return AutomationStepComponent;
}());
export { AutomationStepComponent };
